// src/Layouts/MainLayout.js
import React, { useMemo, useState, useEffect } from 'react';
import { Divider, Dropdown, Layout, Modal } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { clearAuth } from '../auth';
import { FaUser, FaArrowLeft, FaCaretDown } from 'react-icons/fa';
import { FaCircleUser } from 'react-icons/fa6';
import { LogoutOutlined } from '@ant-design/icons';
const { Content } = Layout;

export default function MainLayout() {
    const navigate = useNavigate();
    const location = useLocation();
    const [title, setTitle] = useState('');
    const [visible, setVisible] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        setTitle('Painel do GaPQEI');
        setVisible(true);
    }, [location.pathname]);

    const goLogout = () => {
        clearAuth();
        navigate('/login');
    };

    const goBack = () => navigate(-1);

    const user = (() => {
        try {
            return JSON.parse(sessionStorage.getItem('user')) || {};
        } catch {
            return {};
        }
    })();

    const menu = useMemo(() => ({
        items: [
            {
                key: 'profile-header',
                disabled: true,
                label: (
                    <div className="flex flex-col items-center gap-2">
                        <FaCircleUser color="#047D4B" size={20} />
                        <span className="text-black">{user.nome}</span>
                    </div>
                ),
            },
            { type: 'divider' },
            {
                key: 'profile',
                icon: <FaUser />,
                label: 'Meu Perfil',
                onClick: () => navigate('/meu-perfil'),
            },
            {
                key: 'logout',
                icon: <LogoutOutlined />,
                label: 'Terminar sessão',
                onClick: () => setModalVisible(true),
            },
        ],
    }), [navigate, user.nome]);

    if (!visible) return null;

    return (
        <Layout className="mx-auto" style={{ minHeight: '100vh', backgroundColor: 'white', maxWidth: '1200px' }}>
            <Layout style={{ backgroundColor: 'white' }}>
                <div style={{ position: 'sticky', top: 0, zIndex: 999, backgroundColor: 'white' }}>
                    <div className="flex flex-row justify-between items-center px-4 py-2">
                        <div className="mb-0 py-2 flex gap-2 items-center bg-white">
                            <img
                                src={require('../assets/logo/logo-v2.png')}
                                className="h-16 md:h-16 w-auto"
                                alt="UEM Logo"
                            />
                            <Divider type="vertical" style={{ height: '60px', borderWidth: '2px', borderColor: '#047D4B' }} />
                            <div className="flex flex-col gap-1">
                                <div className="text-2xl md:text-3xl font-bold text-green-700 leading-none">Alumni</div>
                                <div className="text-xs md:text-sm font-semibold text-gray-500 leading-tight">PORTAL DO GRADUADO</div>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <Dropdown menu={menu} trigger={['click']}>
                                <button
                                    type="button"
                                    className="ant-dropdown-link inline-flex items-center gap-2 rounded-full border border-gray-200 bg-white px-2.5 py-1.5 shadow-sm hover:border-emerald-300 transition-colors cursor-pointer"
                                    onClick={e => e.preventDefault()}
                                >
                                    <div className="flex items-center gap-2">
                                        {sessionStorage.getItem('profile') ? (
                                            // profile stored as data URL or path
                                            // eslint-disable-next-line jsx-a11y/alt-text
                                            <img src={sessionStorage.getItem('profile')} className="w-9 h-9 rounded-full object-cover border border-gray-200" />
                                        ) : (
                                            <div className="w-9 h-9 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center">
                                                <FaCircleUser size={24} color="#047D4B" />
                                            </div>
                                        )}
                                        <span className="hidden sm:inline text-sm text-gray-700 max-w-[140px] truncate">
                                            {user.username}
                                        </span>
                                        <FaCaretDown color="#6c7072" size={12} />
                                    </div>
                                </button>
                            </Dropdown>
                        </div>
                    </div>

                    <div className="w-full">
                        <div className="flex flex-row w-full justify-between px-4 py-1 border-b-2 border-gray-500 border-t-2">
                            <div className="flex items-center gap-3">
                                {localStorage.getItem('type') === '2' && <FaArrowLeft size={20} color="black" onClick={goBack} className="cursor-pointer" />}
                                <div className="text-base sm:text-lg font-bold" style={{ color: 'black' }}>
                                    {title}
                                </div>
                            </div>
                        </div>
                    </div>

                    <Modal
                        title="Sair do sistema"
                        centered
                        open={modalVisible}
                        onOk={goLogout}
                        onCancel={() => setModalVisible(false)}
                        okButtonProps={{ danger: true }}
                    >
                        <p>Deseja sair do sistema?</p>
                    </Modal>
                </div>

                <div className="flex w-full py-3">
                    <Content className="p-2 rounded-md" style={{ border: '1px solid #f0f0f0', overflow: 'hidden', backgroundColor: '#F7F8FA' }}>
                        <Outlet />
                    </Content>
                </div>

                <div className="w-full">
                    <div className="flex flex-row w-full px-4 py-2 border-b-2 border-gray-500 border-t-2 mt-4 items-center">
                        <div className="text-xs sm:text-xs font-bold" style={{ color: 'black' }}>
                            Copyright &copy; {new Date().getFullYear()} UEM - Todos Direitos Reservados
                        </div>
                        <div className="ml-auto">
                            <div className="text-xs font-bold mr-2 hidden sm:block" style={{ color: 'black' }}>
                                Email: alumni@uem.ac.mz
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </Layout>
    );
}
